import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-arrow-thin-right",
  "use": "icon-si-glyph-arrow-thin-right-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-arrow-thin-right\" id=\"icon-si-glyph-arrow-thin-right\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1159</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M16.992,7.98 L10.687,14.673 C10.228,15.132 9.527,14.969 9.328,14.767 C8.926,14.364 8.986,13.769 9.389,13.365 L13.284,8.927 L1.97,8.925 C1.458,8.924 1.044,8.499 1.043,7.973 C1.042,7.448 1.458,7.022 1.97,7.023 L13.182,7.01 L9.327,2.739 C8.925,2.335 8.925,1.68 9.327,1.278 C9.727,0.873 10.277,0.974 10.679,1.379 L16.992,7.98 L16.992,7.98 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-arrow-thin-right.svg
// module id = jnWQ
// module chunks = 62